import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';

export type ChangeListProps = { label: string; children: ReactNode };
export type ChangeListRowProps = { ariaLabel: string; identity: ReactNode; action?: ReactNode; children: ReactNode };

/** 대상과 변경 값을 나란히 표시하는 목록입니다. 값 해석과 작업은 호출자가 소유합니다. */
export function ChangeList({ label, children }: ChangeListProps) {
  return <Box component="ul" aria-label={label} sx={{ p: 0, m: 0, listStyle: 'none', border: 1, borderColor: 'divider', borderRadius: designTokens.radius.input, '& > li + li': { borderTop: 1, borderColor: designTokens.color.divider } }}>{children}</Box>;
}

export function ChangeListRow({ ariaLabel, identity, action, children }: ChangeListRowProps) {
  return <Box component="li" aria-label={ariaLabel} sx={{ p: { xs: `${designTokens.space.md}px`, sm: `${designTokens.space.md + designTokens.space.xxs}px` }, display: 'grid', gridTemplateColumns: { xs: action ? 'minmax(0, 1fr) auto' : 'minmax(0, 1fr)', sm: action ? 'minmax(160px, 1fr) minmax(0, 1.4fr) auto' : 'minmax(160px, 1fr) minmax(0, 1.4fr)' }, columnGap: `${designTokens.space.md}px`, rowGap: `${designTokens.space.md}px`, alignItems: 'center' }}>
    <Box sx={{ minWidth: 0 }}>{identity}</Box>
    <Box sx={{ minWidth: 0, gridColumn: { xs: '1 / -1', sm: 2 }, gridRow: { xs: 2, sm: 1 } }}>{children}</Box>
    {action && <Box sx={{ gridColumn: { xs: 2, sm: 3 }, gridRow: 1, alignSelf: 'start' }}>{action}</Box>}
  </Box>;
}
